import { Box, Column, Columns, Stack } from 'braid-design-system';
import type { FC } from 'react';

type Props = {
  applicationQuestions: JSX.Element | null;
  skills: JSX.Element | null;
  highFitSummary: JSX.Element | null;
  applicationAttachments: JSX.Element | null;
  priorityApplyInformation: JSX.Element | null;
  careerHistory: JSX.Element | null;
  educationHistory: JSX.Element | null;
  licencesAndCertification: JSX.Element | null;
  digitalId: JSX.Element | null;
  employementStatus: JSX.Element | null;
  verifiedCredentials: JSX.Element | null;
};

export const ProfileBodyLayout: FC<Props> = ({
  applicationQuestions,
  skills,
  highFitSummary,
  applicationAttachments,
  priorityApplyInformation,
  careerHistory,
  educationHistory,
  licencesAndCertification,
  digitalId,
  employementStatus,
  verifiedCredentials,
}) => (
  <Box paddingBottom="xlarge" data={{ cy: 'profile-data' }}>
    <Columns space="large" collapseBelow="tablet" reverse>
      <Column width="1/3">{highFitSummary}</Column>
      <Column width="2/3">
        <Stack space="large">
          {applicationAttachments}
          {priorityApplyInformation}
          {careerHistory}
          {educationHistory}
          {licencesAndCertification}
          {digitalId}
          {employementStatus}
          {applicationQuestions}
          {skills}
          {verifiedCredentials}
        </Stack>
      </Column>
    </Columns>
  </Box>
);
